

$(document).ready(function() {
completePaymentPlans();

});

function loginAndStoreToken(callback) {
  var settings = {
    "url": "https://pixemix.teampumpkin.in/api/login",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json"
    },
    "data": JSON.stringify({
      "email": "admin@admin.com",
      "password": "admin@123"
    }),
  };
  
  $.ajax(settings).done(function (response) {
    // Store the access token in local storage
    localStorage.setItem('access_token', response.access_token);
    console.log('Login successful. Access token stored:', response.access_token);
    
    // Call the callback function if provided
    if (callback) {
      callback();
    }
  });
}



function completePaymentPlans() {
  let bearer_token = localStorage.getItem('access_token');
  
  // Check if the token is not found
  if (!bearer_token) {
    console.log('No access token found. Logging in...');
    loginAndStoreToken(completePaymentPlans);
  } else {
    var settings = {
      "url": "https://pixemix.teampumpkin.in/api/complete-payment-plans",
      "method": "GET",
      "timeout": 0,
      "headers": {
        "Authorization": "Bearer " + bearer_token
      },
    };
    
    $.ajax(settings).done(function (response) {
      console.log(response);
    });
  }
}

